<template>
    <div class="css">
        <vuestic-widget header-text="GRID CSS">
            <div class="container">
                <div class="item1 item" @click="alert">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aut blanditiis eos, et quaerat repellendus unde voluptas voluptates. Accusamus delectus dolores libero magni maiores maxime minus porro quia quo quos!</div>
                <div class="item" @click="alert">Lorem ipsum dolor sit amet, consectetur adipisicing elit. A animi consectetur cupiditate deleniti eligendi excepturi laborum minima molestias mollitia necessitatibus, nemo nesciunt nostrum nulla numquam quos reiciendis repudiandae rerum voluptas!</div>
                <div class="item" @click="alert">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus at quas qui rerum temporibus voluptate voluptatem? Ad assumenda consectetur id illo iure minus nihil, nostrum obcaecati, quasi rem temporibus voluptatem.</div>
                <div class="item" @click="alert">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus at quas qui rerum temporibus voluptate voluptatem? Ad assumenda consectetur id illo iure minus nihil, nostrum obcaecati, quasi rem temporibus voluptatem.</div>
                <div class="item" @click="alert">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus at quas qui rerum temporibus voluptate voluptatem? Ad assumenda consectetur id illo iure minus nihil, nostrum obcaecati, quasi rem temporibus voluptatem.</div>
                <div class="item" @click="alert">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus at quas qui rerum temporibus voluptate voluptatem? Ad assumenda consectetur id illo iure minus nihil, nostrum obcaecati, quasi rem temporibus voluptatem.</div>
                <div class="item" @click="alert">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus at quas qui rerum temporibus voluptate voluptatem? Ad assumenda consectetur id illo iure minus nihil, nostrum obcaecati, quasi rem temporibus voluptatem.</div>
                <div class="item" @click="alert">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus at quas qui rerum temporibus voluptate voluptatem? Ad assumenda consectetur id illo iure minus nihil, nostrum obcaecati, quasi rem temporibus voluptatem.</div>
                <div class="item" @click="alert">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus at quas qui rerum temporibus voluptate voluptatem? Ad assumenda consectetur id illo iure minus nihil, nostrum obcaecati, quasi rem temporibus voluptatem.</div>
            </div>
        </vuestic-widget>
        <vuestic-modal :force="true" ref="staticModal">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium alias aliquam commodi dicta dolore, dolorum excepturi fugit impedit labore neque officia perspiciatis quia rem repellendus similique suscipit tempora tenetur unde.</p>
        </vuestic-modal>
    </div>
</template>

<script>
    import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
    import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
    export default {
        name: "reporteInventario",
        components: {VuesticModal, VuesticWidget},
        data(){
            return{
                show:true,
            }
        },
        methods:{
            alert(){
                this.$refs.staticModal.open()
            }
        }
    }
</script>

<style scoped lang="scss">
    .container {
        display: grid;
        /*grid-template-columns: 200px 200px 200px;*/
        /*column-gap: 20px;*/
        grid-gap: 20px;
        /*grid-template-columns: 4fr 4fr 4fr;*/
        grid-template-columns: repeat(3, 2fr);
        grid-template-rows: 1fr 1fr;
        grid-auto-rows: 1fr;
    }
    .item{
        background: #555555;
        padding: 10px;
        font-weight: bold;
        color:black;
        text-align: center;
        width: 100%;
        border-radius: 10px;
        transition: all .2s ease-out;
        position: relative;

        &:hover{
            /*background: rgba(0,0,100,0.3);*/
            cursor: pointer;
            /*color: #000;*/
            transform: scale(.8);
            /*box-shadow:  15px 10px 5px 3px rgba(0,0,0,0.4);*/
        }
    }
</style>
